import { Collapse, HStack, IconButton, View } from "native-base";
import React from "react";
import { faTimes } from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import Text from "../components_v2/TextFont";
import { translate } from "../locales/translate";

type Props = {
  message: string | null;
  closeHandler: () => void;
};

const AppWidgetAnnouncement = (props: Props) => {
  return (
    <View
      style={{
        // backgroundColor: Theme.COLORS.ERROR + "20",
        backgroundColor: "#fce4e2",
        borderRadius: 5,
        padding: 15,
        marginTop: 10,
      }}
    >
      <HStack space="2" justifyContent="space-between" alignItems="center">
        <Text style={{ fontSize: 10, textAlign: "justify", flex: 1 }}>
          <Text
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: Theme.COLORS.ERROR,
            }}
          >
            {translate("app.announcement") + " : "}
          </Text>
          {props.message}
        </Text>
        <IconButton
          alignSelf="center"
          variant="outline"
          style={{
            backgroundColor: Theme.COLORS.WHITE,
            borderColor: Theme.COLORS.GRAY_LIGHT,
            width: 35,
            height: 35,
            padding: 0,
          }}
          onPress={props.closeHandler}
          icon={
            <FontAwesomeIcon
              icon={faTimes}
              size={12}
              color={Theme.COLORS.GRAY_DARK}
            />
          }
        />
      </HStack>
    </View>
  );
};

export default AppWidgetAnnouncement;
